import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import {
  fetchHomepageIfNeeded,
  fetchTrendingTopicsYoutubeIfNeeded,
  fetchTrendingTopicsTwitterIfNeeded,
  fetchTrendingTopicsTikTokIfNeeded,
  fetchTrendingTopicsInstagramIfNeeded,
  fetchTrendingTopicsDateIfNeeded,
  fetchTrendingTopicsExportIfNeeded,
  setSelectedTrendDate,
  setSelectedSidebarNav,
  logout
} from '../../actions'
import {
  makeTwitterTrendsSelector,
  makeYouTubeTrendsSelector,
  makeTikTokTrendsSelector,
  makeInstagramTrendsSelector,
  makeTrendingDateSelector,
  makeTrendingTopicsExportSelector
} from '../../selectors'
import TrendingComponent from '../../components/trending/TrendingComponent'
import SidebarComponent from '../../components/sidebar/SidebarComponent'
import Profile from '../../classes/profile'
import { LS_HOMEPAGE_KEY } from '../../constants/local_storage'
import GoogleAnalytics from '../../classes/GoogleAnalytics'
import { CALENDAR_MODULE } from '../../constants/commons'

import NotFound from '../../components/NotFound'

class TrendingContainer extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    profile: Profile.PropTypes,
    history: PropTypes.object,
    match: PropTypes.object,
    homepage: PropTypes.object,
    twitterTrends: PropTypes.object,
    youtubeTrends: PropTypes.object,
    tikTokTrends: PropTypes.object,
    instagramTrends: PropTypes.object,
    trendingDate: PropTypes.object,
    trendingTopicsExport: PropTypes.object,
    logout: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    fetchHomepage: PropTypes.func.isRequired,
    fetchTrendingTopicsYoutube: PropTypes.func.isRequired,
    fetchTrendingTopicsTwitter: PropTypes.func.isRequired,
    fetchTrendingTopicsTikTok: PropTypes.func.isRequired,
    fetchTrendingTopicsInstagram: PropTypes.func.isRequired,
    fetchTrendingTopicsDate: PropTypes.func.isRequired,
    fetchTrendingTopicsExport: PropTypes.func.isRequired,
    setSelectedTrendDate: PropTypes.func.isRequired,
    selectedNav: PropTypes.string,
    isContentIntelligence: PropTypes.bool,
    isCatalogAnalysis: PropTypes.bool,
    isPerformanceAnalysis: PropTypes.bool,
    isAIInsights: PropTypes.bool,
    selectedSidebarNav: PropTypes.func,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string
    }),
    setShortcutPreference: PropTypes.func,
    shortcutPreference: PropTypes.string
  }

  componentDidMount () {
    GoogleAnalytics.trackGA(CALENDAR_MODULE, this.props.location, this.props.profile)
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    if (!homepage) {
      if (this.props.profile && this.props.profile.groups.length > 0) {
        const groups = this.props.profile.groups
        const groupName = groups.filter(group => group !== 'Admin')[0]
        this.props.fetchHomepage(groupName)
      }
    }
    const date = new Date(Date.now() - 86400000).toISOString().split('T')[0] //yesterday's date
    this.props.setSelectedTrendDate(date)
    this.props.fetchTrendingTopicsYoutube(date)
    this.props.fetchTrendingTopicsTwitter(date)
    this.props.fetchTrendingTopicsTikTok(date)
    this.props.fetchTrendingTopicsInstagram(date)
    this.props.fetchTrendingTopicsDate()
  }

  render () {
    const { profile, location, selectedNav, isContentIntelligence, isCatalogAnalysis, isPerformanceAnalysis, isAIInsights, shortcut, twitterTrends, youtubeTrends, tikTokTrends, instagramTrends, trendingDate, trendingTopicsExport } = this.props
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    const myLogout = () => this.props.logout()
    return (
      <>
        <SidebarComponent
          isAdmin={this.props.isAdmin}
          profile={profile}
          logout={myLogout}
          location={location}
          shortcut={shortcut}
          homepage={homepage ? homepage : this.props.homepage}
          selectedSidebarNav={this.props.selectedSidebarNav}
          shortcutPreference={this.props.shortcutPreference}
          setShortcutPreference={this.props.setShortcutPreference}
          selectedNav={selectedNav}
          isContentIntelligence={isContentIntelligence}
          isCatalogAnalysis={isCatalogAnalysis}
          isPerformanceAnalysis={isPerformanceAnalysis}
          isAIInsights={isAIInsights}
        />
        {
          (!this.props.shortcut && homepage && homepage.details && !homepage.details.is_trending_topics) ? (
            <NotFound isAdmin={this.props.isAdmin} />
          ) : (
            <TrendingComponent
              twitterTrends={twitterTrends}
              youtubeTrends={youtubeTrends}
              tikTokTrends={tikTokTrends}
              instagramTrends={instagramTrends}
              trendingDate={trendingDate}
              trendingTopicsExport={trendingTopicsExport}
              setSelectedTrendDate={this.props.setSelectedTrendDate}
              fetchTrendingTopicsTwitter={this.props.fetchTrendingTopicsTwitter}
              fetchTrendingTopicsYoutube={this.props.fetchTrendingTopicsYoutube}
              fetchTrendingTopicsTikTok={this.props.fetchTrendingTopicsTikTok}
              fetchTrendingTopicsInstagram={this.props.fetchTrendingTopicsInstagram}
              fetchTrendingTopicsDate={this.props.fetchTrendingTopicsDate}
              fetchTrendingTopicsExport={this.props.fetchTrendingTopicsExport}
            />
          )
        }
      </>
    )
  }
}

const mapStateToProps = () => {
  const twitterTrendsSelector = makeTwitterTrendsSelector()
  const youTubeTrendsSelector = makeYouTubeTrendsSelector()
  const tikTokTrendsSelector = makeTikTokTrendsSelector()
  const instagramTrendsSelector = makeInstagramTrendsSelector()
  const trendingDateSelector = makeTrendingDateSelector()
  const trendingTopicsExportSelector = makeTrendingTopicsExportSelector()
  return (state, ownProps) => {
    const isAdmin = state.user.isAdmin
    const profile = state.user.profile && new Profile(state.user.profile)
    const shortcut = ownProps.shortcut
    const homepage = state.homepage.list
    const selectedNav = state.sidebar.selectedNav
    const isContentIntelligence = state.sidebar.isContentIntelligence
    const isCatalogAnalysis = state.sidebar.isCatalogAnalysis
    const isPerformanceAnalysis = state.sidebar.isPerformanceAnalysis
    const isAIInsights = state.sidebar.isAIInsights
    const twitterTrends = twitterTrendsSelector(state, ownProps)
    const youtubeTrends = youTubeTrendsSelector(state, ownProps)
    const tikTokTrends = tikTokTrendsSelector(state, ownProps)
    const instagramTrends = instagramTrendsSelector(state, ownProps)
    const trendingDate = trendingDateSelector(state, ownProps)
    const trendingTopicsExport = trendingTopicsExportSelector(state, ownProps)
    return {
      isAdmin,
      profile,
      homepage,
      shortcut,
      selectedNav,
      isContentIntelligence,
      isCatalogAnalysis,
      isPerformanceAnalysis,
      isAIInsights,
      twitterTrends,
      youtubeTrends,
      tikTokTrends,
      instagramTrends,
      trendingDate,
      trendingTopicsExport
    }
  }
}

function mapDispatchToProps () {
  return (dispatch) => {
    return {
      fetchHomepage: (groupName) => dispatch(fetchHomepageIfNeeded(groupName)),
      fetchTrendingTopicsYoutube: (date) => dispatch(fetchTrendingTopicsYoutubeIfNeeded(date)),
      fetchTrendingTopicsTwitter: (date) => dispatch(fetchTrendingTopicsTwitterIfNeeded(date)),
      fetchTrendingTopicsTikTok: (date) => dispatch(fetchTrendingTopicsTikTokIfNeeded(date)),
      fetchTrendingTopicsInstagram: (date) => dispatch(fetchTrendingTopicsInstagramIfNeeded(date)),
      fetchTrendingTopicsDate: () => dispatch(fetchTrendingTopicsDateIfNeeded()),
      fetchTrendingTopicsExport: (date) => dispatch(fetchTrendingTopicsExportIfNeeded(date)),
      setSelectedTrendDate: (date) => dispatch(setSelectedTrendDate(date)),
      selectedSidebarNav: (nav) => dispatch(setSelectedSidebarNav(nav)),
      logout: () => dispatch(logout())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TrendingContainer)